import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {
        omsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        omsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },

        omsdel(context, payload) {
            return D.del({
                ...payload
            })
        },

        stmsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        stmsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },

        stmsdel(context, payload) {
            return D.del({
                ...payload
            })
        },
        dcmsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        dcmsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },

        dcmsdel(context, payload) {
            return D.del({
                ...payload
            })
        },
        salemsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        salemsdel(context, payload) {
            return D.del({
                ...payload
            })
        },

        salemsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },
       
        wxmsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        wxmsdel(context, payload) {
            return D.del({
                ...payload
            })
        },

        wxmsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },

        mbmsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        mbmsdel(context, payload) {
            return D.del({
                ...payload
            })
        },

        mbmsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },

        actsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        actsdel(context, payload) {
            return D.del({
                ...payload
            })
        },

        actsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },

        urmsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        urmsdel(context, payload) {
            return D.del({
                ...payload
            })
        },

        urmsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },

        paysquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        paysdel(context, payload) {
            return D.del({
                ...payload
            })
        },

        paysoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },

        //V5
        omsqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        omsoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },

        omsdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },

        stmsqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        stmsoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },

        stmsdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },
        dcmsqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        dcmsoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },

        dcmsdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },
        salemsqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        salemsdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },

        salemsoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },
       
        wxmsqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        wxmsdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },

        wxmsoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },

        mbmsqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        mbmsdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },

        mbmsoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },

        actsqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        actsdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },

        actsoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },

        urmsqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        urmsdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },

        urmsoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },

        paysqueryv5(context, payload) {
            return D.select({
                ...payload
            })
        },

        paysdelv5(context, payload) {
            return D.del({
                ...payload
            })
        },

        paysoperatev5(context, payload) {
            return D.edit({
                ...payload
            })
        },

        zlscmsquery(context, payload) {
            return D.select({
                ...payload
            })
        },

        zlscmsdel(context, payload) {
            return D.del({
                ...payload
            })
        },

        zlscmsoperate(context, payload) {
            return D.edit({
                ...payload
            })
        },
    }
}